import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';

// Public payment routes go through the DA API Gateway (REACT_APP_PORT_BACKEND),
// which mounts /billing/pay as a public proxy — no JWT, no API key.
const GATEWAY_BASE = process.env.REACT_APP_PORT_BACKEND ?? '';

export class ApiPublicPayment {
  static apiResponse: ApiResponse

  public static async getPaymentDetails(token: string): Promise<ApiResponse> {
    let url: string = `${GATEWAY_BASE}/billing/pay/${token}`

    await axios.get(url).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: null
      }
    })

    return this.apiResponse
  }

  public static async checkout(token: string): Promise<ApiResponse> {
    let url: string = `${GATEWAY_BASE}/billing/pay/${token}/checkout`

    await axios.post(url, {}).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }

  public static async getPaymentStatus(token: string): Promise<ApiResponse> {
    let url: string = `${GATEWAY_BASE}/billing/pay/${token}/status`

    await axios.get(url).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: null
      }
    })

    return this.apiResponse
  }
}
